export class InfoSiteRequest {
    public uid: string | null = null;
    public receptionDate: Date | null = null;
    public sourceUid: string | null = null;
    public passportStatus: PassportStatus = new PassportStatus();
    public internalStatus: InternalStatus = new InternalStatus();
    public clones: InfoSiteRequest[] = [];

    actual(): InfoSiteRequest {
        let actual: InfoSiteRequest = this;
        while (actual.clones.length > 0){
            actual = actual.clones[0];
        }
        return actual;
    }
}

export class PassportStatus {
    public code: string | null = null;
    public name: string | null = null;
    public description: string | null = null;
    public color: string | null = null;
    public subscription: boolean | null = null;
}

export class InternalStatus {
    public name: string | null = null;
    public percent: number | null = null;
}
